export default __webpack_public_path__ + "static/media/grinning_face_with_smiling_eyes.599dba6e.png";